import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/client/dashboard';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/dashboard')({
  beforeLoad: clientGuard,
  component: DashboardRoute,
});

function DashboardRoute() {
  return <DashboardPage />;
}
